import Vue from 'vue'
import Router from 'vue-router'
import _import from './_import'
import mobileRoutes from './mobileRoutes'
import otherRoutes from './otherRoutes'


const Layout = _import('layout/Layout')

/** 备课页面 */
const PreparingHome = _import('preparing/Home')
const PreparingEntrance = _import('preparing/Entrance')
const PreparingDetail = _import('preparing/Detail')

/** 授课页面 */
const TeachingHome = _import('teaching/Home')
const TeachingDetail = _import('teaching/Detail')
const TeachingSimulation = _import('teaching/Simulation')

/** 我的班级页面 */
const MyClassHome = _import('myclass/Home')
const MyClassDetail = _import('myclass/Detail')
const MyClassShow = _import('myclass/Show')
const AiWeeklyReport = _import('myclass/AiWeeklyReport')
// 夸克监控
const MyClassMonitor = _import('myclass/Monitor')
/** 我的学习页面 */
const MyStudyHome = _import('myStudy/Home')
const MyStudyResource = _import('myStudy/Resource')

/** 虚拟实验室页面 */
const Experiment = _import('experiment/Home')
const noBookEdit = _import('experiment/noBookEdit')
const noBookPreview = _import('experiment/noBookPreview')

/** 学情分析页面 */
const StudentAnalysis = _import('studentAnalysis/Home')
const WrongBook = _import('wrongBook/Home')
const ExamAnalysisBI = _import('examAnalysisBI/Home')
const AfantiRank = _import('afanti/Rank')

/** 合心录题页面 */
const HxTaskHome = _import('hxTask/Home')
const PreviewPicture = _import('hxTask/PreviewPicture')

/** 全日制AIPT */
const AIPTTaskHome = _import('aiptTask/Home')
const TaskDetail = _import('aiptTask/TaskDetail')
const TargetedLearning = _import('aiptTask/TargetedLearning')
const AuditComposition = _import('aiptTask/AIcomponents/auditComposition')

/** 全日制AI助教 */
const AIAssistant = _import('aiAssistant/Home')
const compositionList = _import('aiAssistant/compositionList/index')
const compositionDetail = _import('aiAssistant/compositionList/detail')
const aiChat = _import('aiAssistant/aiChat/index')

/** 教师工作台页面 */
const WorkbenchHome = _import('workbench/Home')

const NoFoundPage = _import('404/index')
const NoPermissionPage = _import('403/index')
Vue.use(Router)

/**
 * icon : the icon show in the sidebar
 * hidden : if `hidden:true` will not show in the sidebar
 * redirect : if `redirect:none` will not redirct in the levelbar
 * noDropdown : if `noDropdown:true` will not has submenu in the sidebar
 * meta : `{ role: ['admin'] }`  will control the page role
 **/
export const constantRouters = [{
  path: '/',
  component: Layout,
  redirect: '/preparing/navigation',
  name: '首页',
  hidden: true,
  meta: {
    title: '首页'
  }
},

{
  path: '/teacherCorrectDictation',
  component: () => import('@/views/aiptTask/TeacherCorrectDictation.vue'),
  name: '老师批阅',
  hidden: true,
  meta: {
    title: '老师批阅'
  }
},
{
  path: '/auditComposition',
  component: () => import('@/views/aiptTask/AIcomponents/auditComposition.vue'),
  name: 'AI作文批阅',
  hidden: true,
  meta: {
    title: 'AI作文批阅'
  }
},
{
  path: '/404',
  component: NoFoundPage,
  name: '404',
  hidden: true,
  meta: {
    title: '404'
  }
},
{
  path: '/403',
  component: NoPermissionPage,
  name: '403',
  hidden: true,
  meta: {
    title: '403'
  }
},
{
  path: '/nobookPreview',
  component: noBookPreview,
  name: '实验预览',
  hidden: true
},
{
  path: '/preparing',
  component: Layout,
  redirect: '/navigation',
  name: '导航',
  hidden: true,
  children: [{
    path: 'navigation',
    component: PreparingEntrance,
    meta: {
      title: '导航'
    }
  }]
},
{
  path: '/preparing',
  component: Layout,
  redirect: '/home',
  name: '备课',
  hidden: true,
  children: [{
    path: 'home',
    component: PreparingHome,
    meta: {
      title: '备课'
    }
  },
  /**
   * courseId:   用于查询章节列表
   * courseNo：  用户显示章节列表中的第几个
   * chapterId： 用户查询章节下面的资源类型
   * year: 用于后面的接口传参
   * seasonCode: 用于后面的接口传参
   * businessMode: 业务模式
   */
  {
    path: 'detail/:courseId/:chapterId',
    component: PreparingDetail,
    meta: {
      title: '备课详情'
    }
  }
  ]
},
{
  path: '/teaching',
  component: Layout,
  redirect: '/home',
  name: '授课',
  hidden: true,
  children: [{
    path: 'home',
    component: TeachingHome,
    meta: {
      title: '授课'
    }
  },
  {
    path: 'detail/:classId/:lectureNo/:level/:chapterId/:classLectureId/:speakIndex/:businessMode/:courseId/:subjectCode/:isLiveBigClass',
    component: TeachingDetail,
    meta: {
      title: '授课详情'
    }
  },
  {
    path: 'simulation/:lectureNo/:level/:chapterId/:speakIndex/:businessMode',
    component: TeachingSimulation,
    meta: {
      title: '模拟授课'
    }
  }
  ]
},
{
  path: '/myclass',
  component: Layout,
  redirect: '/home',
  name: '我的班级',
  hidden: true,
  children: [{
    path: 'home',
    component: MyClassHome,
    meta: {
      title: '我的班级'
    }
  },
  {
    path: 'show/:classId/:speakIndex/',
    component: MyClassShow,
    meta: {
      title: '班级分组'
    }
  },
  {
    path: 'detail/:classId/:speakIndex/',
    component: MyClassDetail,
    meta: {
      title: '小组'
    }
  },
  {
    path: 'monitor/:classId',
    component: MyClassMonitor,
    meta: {
      title: '夸克监控'
    }
  },
  {
    path: 'aiWeeklyReport/:classId',
    component: AiWeeklyReport,
    meta: {
      title: '周报数据'
    }
  }
  ]
},

{
  path: '/aiptTask',
  component: Layout,
  redirect: '/home',
  name: '任务',
  hidden: true,
  children: [{
    path: 'home',
    component: AIPTTaskHome,
    meta: {
      title: '任务'
    }
  },
  {
    path: 'taskDetail/:taskId/:classId',
    name: '任务详情',
    component: TaskDetail,
    meta: {
      title: '任务详情'
    }
  },
  {
    path: 'targetedLearning',
    name: 'TargetedLearning',
    component: TargetedLearning,
    meta: {
      title: '发布精准学任务'
    }
  }
  ]
},
{
  path: '/mystudy',
  component: Layout,
  redirect: '/home',
  name: '我的学习',
  hidden: true,
  children: [{
    path: 'home',
    component: MyStudyHome,
    meta: {
      title: '我的学习'
    }
  },
  {
    path: 'myStudyRes/:id/:name/',
    component: MyStudyResource,
    meta: {
      title: '学习资源列表'
    }
  }
  ]
},
{
  path: '/experiment',
  component: Layout,
  redirect: '/home',
  name: '虚拟实验室Home',
  hidden: true,
  children: [{
    path: 'home',
    name: '虚拟实验室',
    component: Experiment,
    meta: {
      title: '虚拟实验室'
    }
  },
  {
    path: 'noBookEdit',
    name: '虚拟实验编辑',
    component: noBookEdit,
    meta: {
      title: '虚拟实验编辑'
    }
  }
  ]
},
{
  path: '/studentAnalysis',
  component: Layout,
  redirect: '/home',
  name: '学情',
  hidden: true,
  children: [{
    path: 'home',
    name: '学情分析',
    component: StudentAnalysis,
    meta: {
      title: '学情分析',
      permission: {
        //roles: ['sc_subject_leader','sc_headmaster','sc_teaching_admin']
      }
    }
  },
  {
    path: 'wrongBook',
    name: '错题本',
    component: WrongBook,
    meta: {
      title: '错题本',
      permission: {
        // roles: ['sc_subject_leader','sc_headmaster','sc_teaching_admin']
      }
    }
  },
  {
    path: 'examAnalysisBI',
    name: '新考试分析',
    component: ExamAnalysisBI,
    meta: {
      title: '新考试分析',
      permission: {
        // roles: ['sc_subject_leader','sc_headmaster','sc_teaching_admin']
      }
    }
  },
  {
    path: 'afantiRank',
    name: '排行榜分析',
    component: AfantiRank,
    meta: {
      title: '排行榜分析',
      permission: {
        // roles: ['sc_subject_leader','sc_headmaster','sc_teaching_admin']
      }
    }
  }
  ]
},
{
  path: '/hxTask',
  component: Layout,
  redirect: '/home',
  name: '合心录题Home',
  hidden: true,
  children: [{
    path: 'home',
    name: '合心录题',
    component: HxTaskHome,
    meta: {
      title: '合心录题'
    }
  },
  {
    path: 'perviewPicture',
    name: '录题预览',
    component: PreviewPicture,
    meta: {
      title: '录题预览'
    }
  }
  ]
},

{
  path: '/aiAssistant',
  component: Layout,
  redirect: 'home',
  name: 'Ai助教',
  hidden: true,
  children: [{
    path: 'aiChat',
    component: aiChat,
    meta: {
      title: '青椒助教'
    },
  },
  {
    path: 'home',
    component: AIAssistant,
    meta: {
      title: 'Ai助教'
    },
  },
  {
    path: 'compositionList',
    name: '爱作文',
    component: compositionList,
    meta: {
      title: '爱作文'
    },

  },
  {
    path: '/aiAssistant/compositionList/detail',
    name: '爱作文详情',
    component: compositionDetail,
    meta: {
      title: '爱作文详情'
    }
  }

  ]
},
{
  path: '/workbench',
  component: Layout,
  redirect: '/workbench/home',
  name: '教师工作台',
  hidden: true,
  children: [{
    path: 'home',
    name: '教师工作台',
    component: WorkbenchHome,
    meta: {
      title: '教师工作台'
    }
  }]
},

]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({
    y: 0
  }), // router切换的效果
  routes: [
    ...constantRouters,
    ...mobileRoutes,
    ...otherRoutes
  ]
})

export const asyncRouters = []
